import { Link } from 'react-router-dom'
import './DocsHeader.css'
import logo from '../../assets/aedifyLo.png'

const DocsHeader = ({ onMobileMenuToggle, isMobileMenuOpen }) => {
  return (
    <header className="docs-header">
      <div className="docs-header-container">
        <div className="docs-header-left">
          <Link to="/" className="docs-header-logo" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <img src={logo} alt="Aedify.AI" style={{ width: 'auto', height: '32px' }} />   
          </Link>
          <nav className="docs-header-nav">
            <Link to="/" className="docs-header-link">Docs</Link>
            <a href="#" className="docs-header-link">Updates</a>
          </nav>
        </div>
        <div className="docs-header-right">
          <a href="https://aedify.ai" target="_blank" rel="noopener noreferrer" className="docs-header-link">
            Aedify.AI
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M2.07102 11.3496L0.963318 10.2419L9.2017 1.98864H2.83807L2.85227 0.454545H11.8438V9.46023H10.2955L10.3097 3.09659L2.07102 11.3496Z" fill="currentColor"/>
            </svg>
          </a>
        </div>
        <button 
          className="docs-header-mobile-toggle"
          onClick={onMobileMenuToggle}
          aria-label="Toggle menu"
        >
          <span className={isMobileMenuOpen ? 'open' : ''}></span>
          <span className={isMobileMenuOpen ? 'open' : ''}></span>
          <span className={isMobileMenuOpen ? 'open' : ''}></span>
        </button>
      </div>
    </header>
  )
}

export default DocsHeader
